import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'

const DEFAULT_CNAME = 'api'

/**
 * Maps a cname to a full API URL
 * - 'api' -> https://api.allotrac.io
 * - 'develop-api' -> https://develop-api.allotrac.io
 * - 'localhost' -> http://localhost:3001
 * - Any other value -> https://{cname}.allotrac.io
 */
const cnameToUrl = (cname: string): string => {
  if (cname === 'localhost') {
    return 'http://localhost:3001'
  }
  return `https://${cname}.allotrac.io`
}

/**
 * Gets the API URL from query string parameter or defaults to production
 * Supported query param: ?cname=develop-api
 */
export const getApiUrl = (): string => {
  if (typeof window === 'undefined') {
    return cnameToUrl(DEFAULT_CNAME)
  }

  const params = new URLSearchParams(window.location.search)
  const cnameParam = params.get('cname')

  if (cnameParam) {
    return cnameToUrl(cnameParam)
  }

  return cnameToUrl(DEFAULT_CNAME)
}

/**
 * Creates an Apollo Client configured for public (unauthenticated) access
 * to the Allotrac GraphQL API
 */
const createApolloClient = () => {
  const apiUrl = getApiUrl()

  const httpLink = new HttpLink({
    uri: `${apiUrl}/graphql`,
    headers: {
      'x-public-request': 'true',
    },
  })

  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'network-only', // Always fetch fresh data
        errorPolicy: 'all',
      },
    },
  })
}

export const apolloClient = createApolloClient()
